module.exports = __webpack_public_path__ + "img/star.9a7bef0a.svg";